import { BasePrice, BrandDto, CategoryReference, Currency, ExtendedPriceDto, Product, StatusEnum } from "../../../../models/product-v2";
import { ProductDetailV3, ProductStatusV3, ProductUIVM, VISIBILITY_OPTIONS } from "../../../../models/product-v3";

export class ProductDetailMapper {

  static toVM(
    data: Product | ProductDetailV3,
    isV2: boolean
  ): ProductUIVM {

    return isV2
      ? this.fromV2(data as Product)
      : this.fromV3(data as ProductDetailV3);
  }

  private static fromV2(product: Product): ProductUIVM {
    return {
      id: product.id!,
      storeId: product.storeId ?? undefined,
      externalId: product.externalId,
      sku: product.sku,
      ean: product.ean,
      name: product.name,
      description: product.description,
      status: product.status,

      brand: {
        id: product.brand?.id,
        name: product.brand?.name,
      },

      category: {
        id: product.category?.id,
        name: product.category?.name,
      },

      seo: product.seo,

      images: product.images?.map(img => ({
        url: img.url,
        altText: img.altText,
        order: img.order,
      })) ?? [],

      mainImageUrl: product.images?.[0]?.url,

      pricing: product.pricing,
      basePrice: product.basePrice,

      productRelations: product.productRelations,

      stock: {
        unit: product.stockManagement?.unit,
        quantity: product.stockManagement?.quantity,
        showWithoutStock: product.showWithoutStock,
        branches: product.stocks,
      },

      dimensions: product.dimensions,
      specifications: product.specifications,
      nutritionalWarnings: product.nutritionalWarnings as any,

      isBundle: product.bundle,
      bundleItems: product.bundleItems,

      score: product.score ?? undefined,
      releaseDate: product.releaseDate ?? undefined,

      // 🔥 FLAGS DE UI
      canEdit: true,
      canManageBundle: true,
    };
  }

  private static fromV3(v3: ProductDetailV3): ProductUIVM {
    return {
      id: v3.id,
      productRefId: v3.productRefId,
      name: v3.name,
      description: v3.description,
      status:
        v3.status === ProductStatusV3.ACTIVE
          ? StatusEnum.ACTIVE
          : StatusEnum.INACTIVE,

      brand: {
        id: v3.brand?.id ?? '',
        name: v3.brand?.name ?? '',
      },
      salesContexts: v3.salesContexts?.map(sc => sc.id) ?? [],

      category: {
        id: v3.category?.id ?? '',
        name: v3.category?.name ?? '',
        externalId: v3.category?.externalId ?? '',
      },
  
      seo: {
        metaTitle: v3.seo?.metaTitle ?? '',
        metaDescription: v3.seo?.metaDescription ?? '',
        keywords: v3.seo?.keywords ?? '',
        permalink: v3.seo?.permalink ?? '',
      },
  
      images: [],
      pricing: {
        base: new ExtendedPriceDto(),
        branches: [
          {
            prices: [],
            id: "",
            name: ""
          }
        ]
      },
      stock: {
        unit: undefined,
        quantity: undefined,
        showWithoutStock: false,
        branches: [],
      },

      dimensions: {
        heightInCm: undefined,
        widthInCm: undefined,
        lengthInCm: undefined,
        weightInGrams: undefined,
      },

      score: v3.score ?? undefined,
      releaseDate: v3.releaseDate
      ? v3.releaseDate.split('T')[0]
      : undefined,
    
      visibility:
      VISIBILITY_OPTIONS.find(v => v.code === v3.visibility) ??
      VISIBILITY_OPTIONS[0],
      // 🔥 FLAGS DE UI
      canEdit: true,
      canManageBundle: false,
    };
  }
}
